import {useInfiniteQuery} from 'react-query';
import {getPostLists} from 'services/postList';
interface GetpostListParms extends IFilters {
  product_category_guid?: string;
  app: 'farm' | 'market';
  order_by: string;
  search: string;
}

const useGetpostList = (params: GetpostListParms) => {
  const {
    data: postListData,
    isLoading,
    refetch,
    fetchNextPage,
  } = useInfiniteQuery(
    [
      'post-list',
      params.app,
      params?.order_by,
      params?.search,
      params?.product_category_guid,
      params?.type,
      params?.start_price,
      params?.end_price,
      params?.type_profile,
      params?.is_grade
    ],
    ({pageParam = 1, queryKey}) =>
      getPostLists({
        page: pageParam,
        app: queryKey[1],
        order_by: queryKey[2],
        search: queryKey[3],
        product_category_guid: queryKey[4],
        type: queryKey[5],
        start_price: queryKey[6],
        end_price: queryKey[7],
        type_profile :  queryKey[8],
        is_grade : queryKey[9]
      }),
    {
      getNextPageParam: (lastPage, allPages) => {
        const lastRecord = allPages[allPages.length - 1]?.next || '';
        return lastRecord
          ? new URL(lastRecord).searchParams.get('page')
          : undefined;
      },
    },
  );
  return {postListData, isLoading, refetch, fetchNextPage};
};
export default useGetpostList;
